import * as React from 'react';
import { useEffect, useRef } from 'react';

interface Props {
  onChangeVisible: (isInViewport: boolean) => void;
}

const InViewport: React.FC<Props> = ({ children, onChangeVisible }) => {
  const ref = useOnScroll(onChangeVisible);

  return <div ref={ref}>{children}</div>;
};

const useOnScroll = (onChangeVisible: (isInViewport: boolean) => void) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    onScroll();
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [ref]);

  const onScroll = () => {
    if (ref.current) {
      const isElemInViewport = ref.current.getBoundingClientRect().bottom <= 60;
      onChangeVisible(isElemInViewport);
    }
  };

  return ref;
};

export default InViewport;
